// HAWK-47 — when the advisor is on a client detail route
// (`/advisor/dashboard/client/<salesforceAccountId>/...`) and clicks Reporting
// in the side nav, we land them on the Builder tab with that household
// already selected. The side nav rewrites the Reporting link URL on the way
// out; the Reporting page reads the params and the Report Builder resolves
// the salesforceAccountId → household.
//
// This module is intentionally tiny and dependency-free so the unit tests can
// run in node mode without pulling Next, Datadog, LaunchDarkly, and the
// UI-kit module graph that the full SideNav component reaches.
const CLIENT_PAGE_PREFIX = '/advisor/dashboard/client/';
const REPORTING_BASE_URL = '/advisor/dashboard/reporting';

export function buildReportingUrlFromCurrentPath(currentPath: string): string {
  if (!currentPath.startsWith(CLIENT_PAGE_PREFIX)) return REPORTING_BASE_URL;
  const after = currentPath.slice(CLIENT_PAGE_PREFIX.length);
  const salesforceAccountId = after.split('/')[0] ?? '';
  if (salesforceAccountId === '') return REPORTING_BASE_URL;
  // tab=1 is the Builder tab (see reporting.tsx — `?tab=N` query-param
  // deep-link). Bundling tab and salesforceAccountId together means a single
  // click from any client subpage lands the advisor on the right tab with
  // the right household already selected.
  return `${REPORTING_BASE_URL}?tab=1&salesforceAccountId=${encodeURIComponent(salesforceAccountId)}`;
}
